import { useEffect, useRef } from 'react';
import { DATA_ATTRIBUTES, DOM_EVENTS, DATA_ATTRIBUTE_NAMES } from '../constants/navigationConstants';

/**
 * Custom hook for handling click outside functionality for Navigation component
 * @param {function} setOpenCategory - Function to set the open category (will be called with null)
 * @param {boolean} isActive - Whether the click outside detection should be active
 */
export const useClickOutsideRef = (setOpenCategory, isActive = true) => {
    const ref = useRef(null);

    useEffect(() => {
        if (!isActive) {
            return;
        }

        const handleClickOutside = (event) => {
            // Check if click is inside the main ref
            if (ref.current && ref.current.contains(event.target)) {
                return;
            }

            // Check if the target or any parent element has our data attributes
            const isOnFavoriteButton = event.target.closest(DATA_ATTRIBUTES.FAVORITE_BUTTON) || event.target.hasAttribute(DATA_ATTRIBUTE_NAMES.FAVORITE_BUTTON);
            const isOnServiceCard = event.target.closest(DATA_ATTRIBUTES.SERVICE_CARD);
            const isOnFlyoutMenu = event.target.closest(DATA_ATTRIBUTES.FLYOUT_MENU);

            if (isOnFavoriteButton || isOnServiceCard || isOnFlyoutMenu) {
                return;
            }

            setOpenCategory(null);
        };

        document.addEventListener(DOM_EVENTS.MOUSE_DOWN, handleClickOutside);
        return () => document.removeEventListener(DOM_EVENTS.MOUSE_DOWN, handleClickOutside);
    }, [setOpenCategory, isActive]);

    return ref;
};
